export default {
  documentTitle: 'KeyPal，您的数字资产硬件钱包，保护您的资产安全',
  product: '产品',
  learn: '学习',
  support: '支持',
  others: '其他',
  language: '语言',
  forBusiness: '商务合作',
  apps: '应用',
  secretBox: 'Secret Box',
  learnMore: '了解更多', 
  goShoppingCart: '前往商城', 
  contactUs: '联系我们:', 
  tutorials: '教程', 
  mobileWallet: '移动钱包', 
  extensionWallet: '插件钱包', 
  cases: '案例:', 
  cooperationSolution: '合作方案', 
  information: '信息', 
  security: '安全', 
  darkMode: '暗黑模式',
  KeyPal_2_firmware: 'KeyPal 2 固件', 
  KeyPal_Plus_firmware: 'KeyPal Plus 固件',
  more: '及更多。',
  comingSoon: '敬请期待',
}
